import { Checkbox, type CheckboxProps } from '@sapphire-react/core';
import { ReactNode } from 'react';
import { Controller } from 'react-hook-form';
import { FormFieldProps } from '../types';

type Props = Omit<CheckboxProps, 'value| name'> & {
  name: string;
} & FormFieldProps & {
    children: ReactNode;
  };

export function CheckboxField(props: Props) {
  const { control, name, defaultValue, children, rules, ...rest } = props;

  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      defaultValue={defaultValue || undefined}
      render={({ field: { ...field }, fieldState: { error } }) => (
        <Checkbox
          {...field}
          {...rest}
          id={field.name}
          value={undefined}
          error={error?.message}
          data-test-id={`${name}-checkbox`}
        >
          {children}
        </Checkbox>
      )}
    />
  );
}
